/**
 * Split array into two parts by the first element that matches the condition and move the first part to the end
 * @param baseArray
 * @param findIndexCallback
 */
export const rearrangeArray = <T>(baseArray: T[], findIndexCallback: (value: T) => boolean) => {
    const startIndex = baseArray.findIndex(findIndexCallback);

    if (startIndex === -1) {
        return [...baseArray];
    }

    const startArray = baseArray.slice(startIndex);
    const endArray = baseArray.slice(0, startIndex);

    return startArray.concat(endArray);
};
/**
 * Split array into two parts by the first element that matches the condition and move the first part to the end
 * @param baseArray
 * @param findIndexCallback
 */
export const rearrangeArray = <T>(baseArray: T[], findIndexCallback: (value: T) => boolean) => {
    const startIndex = baseArray.findIndex(findIndexCallback);

    if (startIndex === -1) {
        return [...baseArray];
    }

    const startArray = baseArray.slice(startIndex);
    const endArray = baseArray.slice(0, startIndex);

    return startArray.concat(endArray);
};
